import "./style.css";
import layout from "./layout.html";

export default class MaisonIntro {
  static selector = ".maison__intro";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
